/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as InvoiceFlowRouteImport } from './routes/_invoice-flow'
import { Route as OnboardingRouteImport } from './routes/_onboarding'
import { Route as QuoteFlowRouteImport } from './routes/_quote-flow'
import { Route as loginLoginRouteImport } from './routes/(login)/login'
import { Route as AuthenticatedsuperAdminSuperAdminRouteImport } from './routes/_authenticated/(super-admin)/super-admin'
import { Route as AuthenticatedOrgOrgIdRouteImport } from './routes/_authenticated/org/$orgId'
import { Route as InvoiceFlowOrgOrgIdRouteImport } from './routes/_invoice-flow/org/$orgId'
import { Route as QuoteFlowOrgOrgIdRouteImport } from './routes/_quote-flow/org/$orgId'
import { Route as AuthenticatedOrgOrgIdInterventionsRouteRouteImport } from './routes/_authenticated/org/$orgId/interventions/route'
import { Route as OnboardingOrgOrgIdOnboardingRouteImport } from './routes/_onboarding/org/$orgId/onboarding'
import { Route as AuthenticatedOrgOrgIddashboardDashboardRouteImport } from './routes/_authenticated/org/$orgId/(dashboard)/dashboard'
import { Route as AuthenticatedOrgOrgIdAgendaIndexRouteImport } from './routes/_authenticated/org/$orgId/agenda/index'
import { Route as AuthenticatedOrgOrgIdEquipmentsIndexRouteImport } from './routes/_authenticated/org/$orgId/equipments/index'
import { Route as AuthenticatedOrgOrgIdEquipmentsEquipmentIdRouteImport } from './routes/_authenticated/org/$orgId/equipments/$equipmentId'
import { Route as AuthenticatedOrgOrgIdEquipmentsNewRouteImport } from './routes/_authenticated/org/$orgId/equipments/new'
import { Route as AuthenticatedOrgOrgIdInterventionsIndexRouteImport } from './routes/_authenticated/org/$orgId/interventions/index'
import { Route as AuthenticatedOrgOrgIdInterventionsInterventionIdRouteImport } from './routes/_authenticated/org/$orgId/interventions/$interventionId'
import { Route as AuthenticatedOrgOrgIdInterventionsNewRouteImport } from './routes/_authenticated/org/$orgId/interventions/new'
import { Route as AuthenticatedOrgOrgIdInvoicesIndexRouteImport } from './routes/_authenticated/org/$orgId/invoices/index'
import { Route as AuthenticatedOrgOrgIdInvoicesReconciliationRouteImport } from './routes/_authenticated/org/$orgId/invoices/reconciliation'
import { Route as AuthenticatedOrgOrgIdNotificationsIndexRouteImport } from './routes/_authenticated/org/$orgId/notifications/index'
import { Route as AuthenticatedOrgOrgIdNotificationsAllRouteImport } from './routes/_authenticated/org/$orgId/notifications/all'
import { Route as AuthenticatedOrgOrgIdSettingsCompanyRouteImport } from './routes/_authenticated/org/$orgId/settings/company'
import { Route as AuthenticatedOrgOrgIdSettingsIntegrationRouteImport } from './routes/_authenticated/org/$orgId/settings/integration'
import { Route as AuthenticatedOrgOrgIdSettingsInterventionRulesRouteImport } from './routes/_authenticated/org/$orgId/settings/intervention-rules'
import { Route as AuthenticatedOrgOrgIdSettingsSettingsRouteImport } from './routes/_authenticated/org/$orgId/settings/settings'
import { Route as AuthenticatedOrgOrgIdSitesIndexRouteImport } from './routes/_authenticated/org/$orgId/sites/index'
import { Route as AuthenticatedOrgOrgIdSitesSiteIdRouteImport } from './routes/_authenticated/org/$orgId/sites/$siteId'
import { Route as AuthenticatedOrgOrgIdSitesImportRouteImport } from './routes/_authenticated/org/$orgId/sites/import'
import { Route as AuthenticatedOrgOrgIdSitesNewRouteImport } from './routes/_authenticated/org/$orgId/sites/new'
import { Route as AuthenticatedOrgOrgIdTechniciansIndexRouteImport } from './routes/_authenticated/org/$orgId/technicians/index'
import { Route as AuthenticatedOrgOrgIdTechniciansTechnicianIdRouteImport } from './routes/_authenticated/org/$orgId/technicians/$technicianId'
import { Route as AuthenticatedOrgOrgIdTechniciansNewRouteImport } from './routes/_authenticated/org/$orgId/technicians/new'
import { Route as AuthenticatedOrgOrgIdUsersIndexRouteImport } from './routes/_authenticated/org/$orgId/users/index'
import { Route as AuthenticatedOrgOrgIdUsersUserIdRouteImport } from './routes/_authenticated/org/$orgId/users/$userId'
import { Route as AuthenticatedOrgOrgIdUsersMyProfileRouteImport } from './routes/_authenticated/org/$orgId/users/my-profile'
import { Route as AuthenticatedOrgOrgIdUsersNewRouteImport } from './routes/_authenticated/org/$orgId/users/new'
import { Route as InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteImport } from './routes/_invoice-flow/org/$orgId/invoices/$invoiceId'
import { Route as InvoiceFlowOrgOrgIdInvoicesNewRouteImport } from './routes/_invoice-flow/org/$orgId/invoices/new'
import { Route as QuoteFlowOrgOrgIdQuotesQuoteIdRouteImport } from './routes/_quote-flow/org/$orgId/quotes/$quoteId'
import { Route as QuoteFlowOrgOrgIdQuotesNewRouteImport } from './routes/_quote-flow/org/$orgId/quotes/new'
import { Route as InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRouteImport } from './routes/_invoice-flow/org/$orgId/invoices/$invoiceId.preview'
import { Route as QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRouteImport } from './routes/_quote-flow/org/$orgId/quotes/$quoteId.preview'

const ForgotPasswordLazyRouteImport = createFileRoute('/forgot-password')()
const ResetPasswordLazyRouteImport = createFileRoute('/reset-password')()
const UnauthorizedLazyRouteImport = createFileRoute('/unauthorized')()
const loginAcceptInvitationLazyRouteImport = createFileRoute(
  '/(login)/accept-invitation',
)()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoiceFlowRoute = InvoiceFlowRouteImport.update({
  id: '/_invoice-flow',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const QuoteFlowRoute = QuoteFlowRouteImport.update({
  id: '/_quote-flow',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordLazyRoute = ForgotPasswordLazyRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/forgot-password.lazy').then((d) => d.Route),
)
const ResetPasswordLazyRoute = ResetPasswordLazyRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/reset-password.lazy').then((d) => d.Route),
)
const UnauthorizedLazyRoute = UnauthorizedLazyRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/unauthorized.lazy').then((d) => d.Route))
const loginAcceptInvitationLazyRoute = loginAcceptInvitationLazyRouteImport
  .update({
    id: '/(login)/accept-invitation',
    path: '/accept-invitation',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() =>
    import('./routes/(login)/accept-invitation.lazy').then((d) => d.Route),
  )
const loginLoginRoute = loginLoginRouteImport
  .update({
    id: '/(login)/login',
    path: '/login',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(login)/login.lazy').then((d) => d.Route))
const AuthenticatedsuperAdminSuperAdminRoute =
  AuthenticatedsuperAdminSuperAdminRouteImport.update({
    id: '/(super-admin)/super-admin',
    path: '/super-admin',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/(super-admin)/super-admin.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdRoute = AuthenticatedOrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const InvoiceFlowOrgOrgIdRoute = InvoiceFlowOrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => InvoiceFlowRoute,
} as any)
const QuoteFlowOrgOrgIdRoute = QuoteFlowOrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => QuoteFlowRoute,
} as any)
const AuthenticatedOrgOrgIdInterventionsRouteRoute =
  AuthenticatedOrgOrgIdInterventionsRouteRouteImport.update({
    id: '/interventions',
    path: '/interventions',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const OnboardingOrgOrgIdOnboardingRoute =
  OnboardingOrgOrgIdOnboardingRouteImport.update({
    id: '/org/$orgId/onboarding',
    path: '/org/$orgId/onboarding',
    getParentRoute: () => OnboardingRoute,
  } as any).lazy(() =>
    import('./routes/_onboarding/org/$orgId/onboarding.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIddashboardDashboardRoute =
  AuthenticatedOrgOrgIddashboardDashboardRouteImport.update({
    id: '/(dashboard)/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/(dashboard)/dashboard.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdAgendaIndexRoute =
  AuthenticatedOrgOrgIdAgendaIndexRouteImport.update({
    id: '/agenda/',
    path: '/agenda/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/agenda/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdEquipmentsIndexRoute =
  AuthenticatedOrgOrgIdEquipmentsIndexRouteImport.update({
    id: '/equipments/',
    path: '/equipments/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/equipments/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdEquipmentsEquipmentIdRoute =
  AuthenticatedOrgOrgIdEquipmentsEquipmentIdRouteImport.update({
    id: '/equipments/$equipmentId',
    path: '/equipments/$equipmentId',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/equipments/$equipmentId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdEquipmentsNewRoute =
  AuthenticatedOrgOrgIdEquipmentsNewRouteImport.update({
    id: '/equipments/new',
    path: '/equipments/new',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdInterventionsIndexRoute =
  AuthenticatedOrgOrgIdInterventionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgOrgIdInterventionsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/interventions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdInterventionsInterventionIdRoute =
  AuthenticatedOrgOrgIdInterventionsInterventionIdRouteImport.update({
    id: '/$interventionId',
    path: '/$interventionId',
    getParentRoute: () => AuthenticatedOrgOrgIdInterventionsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/interventions/$interventionId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdInterventionsNewRoute =
  AuthenticatedOrgOrgIdInterventionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedOrgOrgIdInterventionsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/interventions/new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdInvoicesIndexRoute =
  AuthenticatedOrgOrgIdInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdInvoicesReconciliationRoute =
  AuthenticatedOrgOrgIdInvoicesReconciliationRouteImport.update({
    id: '/invoices/reconciliation',
    path: '/invoices/reconciliation',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdNotificationsIndexRoute =
  AuthenticatedOrgOrgIdNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/notifications/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdNotificationsAllRoute =
  AuthenticatedOrgOrgIdNotificationsAllRouteImport.update({
    id: '/notifications/all',
    path: '/notifications/all',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/notifications/all.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdSettingsCompanyRoute =
  AuthenticatedOrgOrgIdSettingsCompanyRouteImport.update({
    id: '/settings/company',
    path: '/settings/company',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/settings/company.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdSettingsIntegrationRoute =
  AuthenticatedOrgOrgIdSettingsIntegrationRouteImport.update({
    id: '/settings/integration',
    path: '/settings/integration',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdSettingsInterventionRulesRoute =
  AuthenticatedOrgOrgIdSettingsInterventionRulesRouteImport.update({
    id: '/settings/intervention-rules',
    path: '/settings/intervention-rules',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/settings/intervention-rules.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdSettingsSettingsRoute =
  AuthenticatedOrgOrgIdSettingsSettingsRouteImport.update({
    id: '/settings/settings',
    path: '/settings/settings',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/settings/settings.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdSitesIndexRoute =
  AuthenticatedOrgOrgIdSitesIndexRouteImport.update({
    id: '/sites/',
    path: '/sites/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/sites/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdSitesSiteIdRoute =
  AuthenticatedOrgOrgIdSitesSiteIdRouteImport.update({
    id: '/sites/$siteId',
    path: '/sites/$siteId',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/sites/$siteId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdSitesImportRoute =
  AuthenticatedOrgOrgIdSitesImportRouteImport.update({
    id: '/sites/import',
    path: '/sites/import',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdSitesNewRoute =
  AuthenticatedOrgOrgIdSitesNewRouteImport.update({
    id: '/sites/new',
    path: '/sites/new',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdTechniciansIndexRoute =
  AuthenticatedOrgOrgIdTechniciansIndexRouteImport.update({
    id: '/technicians/',
    path: '/technicians/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdTechniciansTechnicianIdRoute =
  AuthenticatedOrgOrgIdTechniciansTechnicianIdRouteImport.update({
    id: '/technicians/$technicianId',
    path: '/technicians/$technicianId',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdTechniciansNewRoute =
  AuthenticatedOrgOrgIdTechniciansNewRouteImport.update({
    id: '/technicians/new',
    path: '/technicians/new',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/technicians/new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdUsersIndexRoute =
  AuthenticatedOrgOrgIdUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/users/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdUsersUserIdRoute =
  AuthenticatedOrgOrgIdUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/users/$userId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdUsersMyProfileRoute =
  AuthenticatedOrgOrgIdUsersMyProfileRouteImport.update({
    id: '/users/my-profile',
    path: '/users/my-profile',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/users/my-profile.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdUsersNewRoute =
  AuthenticatedOrgOrgIdUsersNewRouteImport.update({
    id: '/users/new',
    path: '/users/new',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/$orgId/users/new.lazy').then(
      (d) => d.Route,
    ),
  )
const InvoiceFlowOrgOrgIdInvoicesInvoiceIdRoute =
  InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => InvoiceFlowOrgOrgIdRoute,
  } as any)
const InvoiceFlowOrgOrgIdInvoicesNewRoute =
  InvoiceFlowOrgOrgIdInvoicesNewRouteImport.update({
    id: '/invoices/new',
    path: '/invoices/new',
    getParentRoute: () => InvoiceFlowOrgOrgIdRoute,
  } as any)
const QuoteFlowOrgOrgIdQuotesQuoteIdRoute =
  QuoteFlowOrgOrgIdQuotesQuoteIdRouteImport.update({
    id: '/quotes/$quoteId',
    path: '/quotes/$quoteId',
    getParentRoute: () => QuoteFlowOrgOrgIdRoute,
  } as any)
const QuoteFlowOrgOrgIdQuotesNewRoute =
  QuoteFlowOrgOrgIdQuotesNewRouteImport.update({
    id: '/quotes/new',
    path: '/quotes/new',
    getParentRoute: () => QuoteFlowOrgOrgIdRoute,
  } as any)
const InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRoute =
  InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRouteImport.update({
    id: '/preview',
    path: '/preview',
    getParentRoute: () => InvoiceFlowOrgOrgIdInvoicesInvoiceIdRoute,
  } as any)
const QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRoute =
  QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRouteImport.update({
    id: '/preview',
    path: '/preview',
    getParentRoute: () => QuoteFlowOrgOrgIdQuotesQuoteIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/reset-password': typeof ResetPasswordLazyRoute
  '/unauthorized': typeof UnauthorizedLazyRoute
  '/login': typeof loginLoginRoute
  '/accept-invitation': typeof loginAcceptInvitationLazyRoute
  '/super-admin': typeof AuthenticatedsuperAdminSuperAdminRoute
  '/org/$orgId': typeof QuoteFlowOrgOrgIdRouteWithChildren
  '/org/$orgId/interventions': typeof AuthenticatedOrgOrgIdInterventionsRouteRouteWithChildren
  '/org/$orgId/onboarding': typeof OnboardingOrgOrgIdOnboardingRoute
  '/org/$orgId/dashboard': typeof AuthenticatedOrgOrgIddashboardDashboardRoute
  '/org/$orgId/equipments/$equipmentId': typeof AuthenticatedOrgOrgIdEquipmentsEquipmentIdRoute
  '/org/$orgId/equipments/new': typeof AuthenticatedOrgOrgIdEquipmentsNewRoute
  '/org/$orgId/interventions/$interventionId': typeof AuthenticatedOrgOrgIdInterventionsInterventionIdRoute
  '/org/$orgId/interventions/new': typeof AuthenticatedOrgOrgIdInterventionsNewRoute
  '/org/$orgId/invoices/reconciliation': typeof AuthenticatedOrgOrgIdInvoicesReconciliationRoute
  '/org/$orgId/notifications/all': typeof AuthenticatedOrgOrgIdNotificationsAllRoute
  '/org/$orgId/settings/company': typeof AuthenticatedOrgOrgIdSettingsCompanyRoute
  '/org/$orgId/settings/integration': typeof AuthenticatedOrgOrgIdSettingsIntegrationRoute
  '/org/$orgId/settings/intervention-rules': typeof AuthenticatedOrgOrgIdSettingsInterventionRulesRoute
  '/org/$orgId/settings/settings': typeof AuthenticatedOrgOrgIdSettingsSettingsRoute
  '/org/$orgId/sites/$siteId': typeof AuthenticatedOrgOrgIdSitesSiteIdRoute
  '/org/$orgId/sites/import': typeof AuthenticatedOrgOrgIdSitesImportRoute
  '/org/$orgId/sites/new': typeof AuthenticatedOrgOrgIdSitesNewRoute
  '/org/$orgId/technicians/$technicianId': typeof AuthenticatedOrgOrgIdTechniciansTechnicianIdRoute
  '/org/$orgId/technicians/new': typeof AuthenticatedOrgOrgIdTechniciansNewRoute
  '/org/$orgId/users/$userId': typeof AuthenticatedOrgOrgIdUsersUserIdRoute
  '/org/$orgId/users/my-profile': typeof AuthenticatedOrgOrgIdUsersMyProfileRoute
  '/org/$orgId/users/new': typeof AuthenticatedOrgOrgIdUsersNewRoute
  '/org/$orgId/invoices/$invoiceId': typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteWithChildren
  '/org/$orgId/invoices/new': typeof InvoiceFlowOrgOrgIdInvoicesNewRoute
  '/org/$orgId/quotes/$quoteId': typeof QuoteFlowOrgOrgIdQuotesQuoteIdRouteWithChildren
  '/org/$orgId/quotes/new': typeof QuoteFlowOrgOrgIdQuotesNewRoute
  '/org/$orgId/agenda/': typeof AuthenticatedOrgOrgIdAgendaIndexRoute
  '/org/$orgId/equipments/': typeof AuthenticatedOrgOrgIdEquipmentsIndexRoute
  '/org/$orgId/interventions/': typeof AuthenticatedOrgOrgIdInterventionsIndexRoute
  '/org/$orgId/invoices/': typeof AuthenticatedOrgOrgIdInvoicesIndexRoute
  '/org/$orgId/notifications/': typeof AuthenticatedOrgOrgIdNotificationsIndexRoute
  '/org/$orgId/sites/': typeof AuthenticatedOrgOrgIdSitesIndexRoute
  '/org/$orgId/technicians/': typeof AuthenticatedOrgOrgIdTechniciansIndexRoute
  '/org/$orgId/users/': typeof AuthenticatedOrgOrgIdUsersIndexRoute
  '/org/$orgId/invoices/$invoiceId/preview': typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRoute
  '/org/$orgId/quotes/$quoteId/preview': typeof QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/reset-password': typeof ResetPasswordLazyRoute
  '/unauthorized': typeof UnauthorizedLazyRoute
  '/login': typeof loginLoginRoute
  '/accept-invitation': typeof loginAcceptInvitationLazyRoute
  '/super-admin': typeof AuthenticatedsuperAdminSuperAdminRoute
  '/org/$orgId': typeof QuoteFlowOrgOrgIdRouteWithChildren
  '/org/$orgId/onboarding': typeof OnboardingOrgOrgIdOnboardingRoute
  '/org/$orgId/dashboard': typeof AuthenticatedOrgOrgIddashboardDashboardRoute
  '/org/$orgId/equipments/$equipmentId': typeof AuthenticatedOrgOrgIdEquipmentsEquipmentIdRoute
  '/org/$orgId/equipments/new': typeof AuthenticatedOrgOrgIdEquipmentsNewRoute
  '/org/$orgId/interventions/$interventionId': typeof AuthenticatedOrgOrgIdInterventionsInterventionIdRoute
  '/org/$orgId/interventions/new': typeof AuthenticatedOrgOrgIdInterventionsNewRoute
  '/org/$orgId/invoices/reconciliation': typeof AuthenticatedOrgOrgIdInvoicesReconciliationRoute
  '/org/$orgId/notifications/all': typeof AuthenticatedOrgOrgIdNotificationsAllRoute
  '/org/$orgId/settings/company': typeof AuthenticatedOrgOrgIdSettingsCompanyRoute
  '/org/$orgId/settings/integration': typeof AuthenticatedOrgOrgIdSettingsIntegrationRoute
  '/org/$orgId/settings/intervention-rules': typeof AuthenticatedOrgOrgIdSettingsInterventionRulesRoute
  '/org/$orgId/settings/settings': typeof AuthenticatedOrgOrgIdSettingsSettingsRoute
  '/org/$orgId/sites/$siteId': typeof AuthenticatedOrgOrgIdSitesSiteIdRoute
  '/org/$orgId/sites/import': typeof AuthenticatedOrgOrgIdSitesImportRoute
  '/org/$orgId/sites/new': typeof AuthenticatedOrgOrgIdSitesNewRoute
  '/org/$orgId/technicians/$technicianId': typeof AuthenticatedOrgOrgIdTechniciansTechnicianIdRoute
  '/org/$orgId/technicians/new': typeof AuthenticatedOrgOrgIdTechniciansNewRoute
  '/org/$orgId/users/$userId': typeof AuthenticatedOrgOrgIdUsersUserIdRoute
  '/org/$orgId/users/my-profile': typeof AuthenticatedOrgOrgIdUsersMyProfileRoute
  '/org/$orgId/users/new': typeof AuthenticatedOrgOrgIdUsersNewRoute
  '/org/$orgId/invoices/$invoiceId': typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteWithChildren
  '/org/$orgId/invoices/new': typeof InvoiceFlowOrgOrgIdInvoicesNewRoute
  '/org/$orgId/quotes/$quoteId': typeof QuoteFlowOrgOrgIdQuotesQuoteIdRouteWithChildren
  '/org/$orgId/quotes/new': typeof QuoteFlowOrgOrgIdQuotesNewRoute
  '/org/$orgId/agenda': typeof AuthenticatedOrgOrgIdAgendaIndexRoute
  '/org/$orgId/equipments': typeof AuthenticatedOrgOrgIdEquipmentsIndexRoute
  '/org/$orgId/interventions': typeof AuthenticatedOrgOrgIdInterventionsIndexRoute
  '/org/$orgId/invoices': typeof AuthenticatedOrgOrgIdInvoicesIndexRoute
  '/org/$orgId/notifications': typeof AuthenticatedOrgOrgIdNotificationsIndexRoute
  '/org/$orgId/sites': typeof AuthenticatedOrgOrgIdSitesIndexRoute
  '/org/$orgId/technicians': typeof AuthenticatedOrgOrgIdTechniciansIndexRoute
  '/org/$orgId/users': typeof AuthenticatedOrgOrgIdUsersIndexRoute
  '/org/$orgId/invoices/$invoiceId/preview': typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRoute
  '/org/$orgId/quotes/$quoteId/preview': typeof QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_invoice-flow': typeof InvoiceFlowRouteWithChildren
  '/_onboarding': typeof OnboardingRouteWithChildren
  '/_quote-flow': typeof QuoteFlowRouteWithChildren
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/reset-password': typeof ResetPasswordLazyRoute
  '/unauthorized': typeof UnauthorizedLazyRoute
  '/(login)/login': typeof loginLoginRoute
  '/(login)/accept-invitation': typeof loginAcceptInvitationLazyRoute
  '/_authenticated/(super-admin)/super-admin': typeof AuthenticatedsuperAdminSuperAdminRoute
  '/_authenticated/org/$orgId': typeof AuthenticatedOrgOrgIdRouteWithChildren
  '/_invoice-flow/org/$orgId': typeof InvoiceFlowOrgOrgIdRouteWithChildren
  '/_quote-flow/org/$orgId': typeof QuoteFlowOrgOrgIdRouteWithChildren
  '/_authenticated/org/$orgId/interventions': typeof AuthenticatedOrgOrgIdInterventionsRouteRouteWithChildren
  '/_onboarding/org/$orgId/onboarding': typeof OnboardingOrgOrgIdOnboardingRoute
  '/_authenticated/org/$orgId/(dashboard)/dashboard': typeof AuthenticatedOrgOrgIddashboardDashboardRoute
  '/_authenticated/org/$orgId/equipments/$equipmentId': typeof AuthenticatedOrgOrgIdEquipmentsEquipmentIdRoute
  '/_authenticated/org/$orgId/equipments/new': typeof AuthenticatedOrgOrgIdEquipmentsNewRoute
  '/_authenticated/org/$orgId/interventions/$interventionId': typeof AuthenticatedOrgOrgIdInterventionsInterventionIdRoute
  '/_authenticated/org/$orgId/interventions/new': typeof AuthenticatedOrgOrgIdInterventionsNewRoute
  '/_authenticated/org/$orgId/invoices/reconciliation': typeof AuthenticatedOrgOrgIdInvoicesReconciliationRoute
  '/_authenticated/org/$orgId/notifications/all': typeof AuthenticatedOrgOrgIdNotificationsAllRoute
  '/_authenticated/org/$orgId/settings/company': typeof AuthenticatedOrgOrgIdSettingsCompanyRoute
  '/_authenticated/org/$orgId/settings/integration': typeof AuthenticatedOrgOrgIdSettingsIntegrationRoute
  '/_authenticated/org/$orgId/settings/intervention-rules': typeof AuthenticatedOrgOrgIdSettingsInterventionRulesRoute
  '/_authenticated/org/$orgId/settings/settings': typeof AuthenticatedOrgOrgIdSettingsSettingsRoute
  '/_authenticated/org/$orgId/sites/$siteId': typeof AuthenticatedOrgOrgIdSitesSiteIdRoute
  '/_authenticated/org/$orgId/sites/import': typeof AuthenticatedOrgOrgIdSitesImportRoute
  '/_authenticated/org/$orgId/sites/new': typeof AuthenticatedOrgOrgIdSitesNewRoute
  '/_authenticated/org/$orgId/technicians/$technicianId': typeof AuthenticatedOrgOrgIdTechniciansTechnicianIdRoute
  '/_authenticated/org/$orgId/technicians/new': typeof AuthenticatedOrgOrgIdTechniciansNewRoute
  '/_authenticated/org/$orgId/users/$userId': typeof AuthenticatedOrgOrgIdUsersUserIdRoute
  '/_authenticated/org/$orgId/users/my-profile': typeof AuthenticatedOrgOrgIdUsersMyProfileRoute
  '/_authenticated/org/$orgId/users/new': typeof AuthenticatedOrgOrgIdUsersNewRoute
  '/_invoice-flow/org/$orgId/invoices/$invoiceId': typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteWithChildren
  '/_invoice-flow/org/$orgId/invoices/new': typeof InvoiceFlowOrgOrgIdInvoicesNewRoute
  '/_quote-flow/org/$orgId/quotes/$quoteId': typeof QuoteFlowOrgOrgIdQuotesQuoteIdRouteWithChildren
  '/_quote-flow/org/$orgId/quotes/new': typeof QuoteFlowOrgOrgIdQuotesNewRoute
  '/_authenticated/org/$orgId/agenda/': typeof AuthenticatedOrgOrgIdAgendaIndexRoute
  '/_authenticated/org/$orgId/equipments/': typeof AuthenticatedOrgOrgIdEquipmentsIndexRoute
  '/_authenticated/org/$orgId/interventions/': typeof AuthenticatedOrgOrgIdInterventionsIndexRoute
  '/_authenticated/org/$orgId/invoices/': typeof AuthenticatedOrgOrgIdInvoicesIndexRoute
  '/_authenticated/org/$orgId/notifications/': typeof AuthenticatedOrgOrgIdNotificationsIndexRoute
  '/_authenticated/org/$orgId/sites/': typeof AuthenticatedOrgOrgIdSitesIndexRoute
  '/_authenticated/org/$orgId/technicians/': typeof AuthenticatedOrgOrgIdTechniciansIndexRoute
  '/_authenticated/org/$orgId/users/': typeof AuthenticatedOrgOrgIdUsersIndexRoute
  '/_invoice-flow/org/$orgId/invoices/$invoiceId/preview': typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRoute
  '/_quote-flow/org/$orgId/quotes/$quoteId/preview': typeof QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/unauthorized'
    | '/login'
    | '/accept-invitation'
    | '/super-admin'
    | '/org/$orgId'
    | '/org/$orgId/interventions'
    | '/org/$orgId/onboarding'
    | '/org/$orgId/dashboard'
    | '/org/$orgId/equipments/$equipmentId'
    | '/org/$orgId/equipments/new'
    | '/org/$orgId/interventions/$interventionId'
    | '/org/$orgId/interventions/new'
    | '/org/$orgId/invoices/reconciliation'
    | '/org/$orgId/notifications/all'
    | '/org/$orgId/settings/company'
    | '/org/$orgId/settings/integration'
    | '/org/$orgId/settings/intervention-rules'
    | '/org/$orgId/settings/settings'
    | '/org/$orgId/sites/$siteId'
    | '/org/$orgId/sites/import'
    | '/org/$orgId/sites/new'
    | '/org/$orgId/technicians/$technicianId'
    | '/org/$orgId/technicians/new'
    | '/org/$orgId/users/$userId'
    | '/org/$orgId/users/my-profile'
    | '/org/$orgId/users/new'
    | '/org/$orgId/invoices/$invoiceId'
    | '/org/$orgId/invoices/new'
    | '/org/$orgId/quotes/$quoteId'
    | '/org/$orgId/quotes/new'
    | '/org/$orgId/agenda/'
    | '/org/$orgId/equipments/'
    | '/org/$orgId/interventions/'
    | '/org/$orgId/invoices/'
    | '/org/$orgId/notifications/'
    | '/org/$orgId/sites/'
    | '/org/$orgId/technicians/'
    | '/org/$orgId/users/'
    | '/org/$orgId/invoices/$invoiceId/preview'
    | '/org/$orgId/quotes/$quoteId/preview'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/unauthorized'
    | '/login'
    | '/accept-invitation'
    | '/super-admin'
    | '/org/$orgId'
    | '/org/$orgId/onboarding'
    | '/org/$orgId/dashboard'
    | '/org/$orgId/equipments/$equipmentId'
    | '/org/$orgId/equipments/new'
    | '/org/$orgId/interventions/$interventionId'
    | '/org/$orgId/interventions/new'
    | '/org/$orgId/invoices/reconciliation'
    | '/org/$orgId/notifications/all'
    | '/org/$orgId/settings/company'
    | '/org/$orgId/settings/integration'
    | '/org/$orgId/settings/intervention-rules'
    | '/org/$orgId/settings/settings'
    | '/org/$orgId/sites/$siteId'
    | '/org/$orgId/sites/import'
    | '/org/$orgId/sites/new'
    | '/org/$orgId/technicians/$technicianId'
    | '/org/$orgId/technicians/new'
    | '/org/$orgId/users/$userId'
    | '/org/$orgId/users/my-profile'
    | '/org/$orgId/users/new'
    | '/org/$orgId/invoices/$invoiceId'
    | '/org/$orgId/invoices/new'
    | '/org/$orgId/quotes/$quoteId'
    | '/org/$orgId/quotes/new'
    | '/org/$orgId/agenda'
    | '/org/$orgId/equipments'
    | '/org/$orgId/interventions'
    | '/org/$orgId/invoices'
    | '/org/$orgId/notifications'
    | '/org/$orgId/sites'
    | '/org/$orgId/technicians'
    | '/org/$orgId/users'
    | '/org/$orgId/invoices/$invoiceId/preview'
    | '/org/$orgId/quotes/$quoteId/preview'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_invoice-flow'
    | '/_onboarding'
    | '/_quote-flow'
    | '/forgot-password'
    | '/reset-password'
    | '/unauthorized'
    | '/(login)/login'
    | '/(login)/accept-invitation'
    | '/_authenticated/(super-admin)/super-admin'
    | '/_authenticated/org/$orgId'
    | '/_invoice-flow/org/$orgId'
    | '/_quote-flow/org/$orgId'
    | '/_authenticated/org/$orgId/interventions'
    | '/_onboarding/org/$orgId/onboarding'
    | '/_authenticated/org/$orgId/(dashboard)/dashboard'
    | '/_authenticated/org/$orgId/equipments/$equipmentId'
    | '/_authenticated/org/$orgId/equipments/new'
    | '/_authenticated/org/$orgId/interventions/$interventionId'
    | '/_authenticated/org/$orgId/interventions/new'
    | '/_authenticated/org/$orgId/invoices/reconciliation'
    | '/_authenticated/org/$orgId/notifications/all'
    | '/_authenticated/org/$orgId/settings/company'
    | '/_authenticated/org/$orgId/settings/integration'
    | '/_authenticated/org/$orgId/settings/intervention-rules'
    | '/_authenticated/org/$orgId/settings/settings'
    | '/_authenticated/org/$orgId/sites/$siteId'
    | '/_authenticated/org/$orgId/sites/import'
    | '/_authenticated/org/$orgId/sites/new'
    | '/_authenticated/org/$orgId/technicians/$technicianId'
    | '/_authenticated/org/$orgId/technicians/new'
    | '/_authenticated/org/$orgId/users/$userId'
    | '/_authenticated/org/$orgId/users/my-profile'
    | '/_authenticated/org/$orgId/users/new'
    | '/_invoice-flow/org/$orgId/invoices/$invoiceId'
    | '/_invoice-flow/org/$orgId/invoices/new'
    | '/_quote-flow/org/$orgId/quotes/$quoteId'
    | '/_quote-flow/org/$orgId/quotes/new'
    | '/_authenticated/org/$orgId/agenda/'
    | '/_authenticated/org/$orgId/equipments/'
    | '/_authenticated/org/$orgId/interventions/'
    | '/_authenticated/org/$orgId/invoices/'
    | '/_authenticated/org/$orgId/notifications/'
    | '/_authenticated/org/$orgId/sites/'
    | '/_authenticated/org/$orgId/technicians/'
    | '/_authenticated/org/$orgId/users/'
    | '/_invoice-flow/org/$orgId/invoices/$invoiceId/preview'
    | '/_quote-flow/org/$orgId/quotes/$quoteId/preview'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  InvoiceFlowRoute: typeof InvoiceFlowRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  QuoteFlowRoute: typeof QuoteFlowRouteWithChildren
  ForgotPasswordLazyRoute: typeof ForgotPasswordLazyRoute
  ResetPasswordLazyRoute: typeof ResetPasswordLazyRoute
  UnauthorizedLazyRoute: typeof UnauthorizedLazyRoute
  loginLoginRoute: typeof loginLoginRoute
  loginAcceptInvitationLazyRoute: typeof loginAcceptInvitationLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_invoice-flow': {
      id: '/_invoice-flow'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof InvoiceFlowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_quote-flow': {
      id: '/_quote-flow'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof QuoteFlowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(login)/accept-invitation': {
      id: '/(login)/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof loginAcceptInvitationLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(login)/login': {
      id: '/(login)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof loginLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/(super-admin)/super-admin': {
      id: '/_authenticated/(super-admin)/super-admin'
      path: '/super-admin'
      fullPath: '/super-admin'
      preLoaderRoute: typeof AuthenticatedsuperAdminSuperAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgId': {
      id: '/_authenticated/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_invoice-flow/org/$orgId': {
      id: '/_invoice-flow/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof InvoiceFlowOrgOrgIdRouteImport
      parentRoute: typeof InvoiceFlowRoute
    }
    '/_quote-flow/org/$orgId': {
      id: '/_quote-flow/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof QuoteFlowOrgOrgIdRouteImport
      parentRoute: typeof QuoteFlowRoute
    }
    '/_authenticated/org/$orgId/interventions': {
      id: '/_authenticated/org/$orgId/interventions'
      path: '/interventions'
      fullPath: '/org/$orgId/interventions'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdInterventionsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_onboarding/org/$orgId/onboarding': {
      id: '/_onboarding/org/$orgId/onboarding'
      path: '/org/$orgId/onboarding'
      fullPath: '/org/$orgId/onboarding'
      preLoaderRoute: typeof OnboardingOrgOrgIdOnboardingRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_authenticated/org/$orgId/(dashboard)/dashboard': {
      id: '/_authenticated/org/$orgId/(dashboard)/dashboard'
      path: '/dashboard'
      fullPath: '/org/$orgId/dashboard'
      preLoaderRoute: typeof AuthenticatedOrgOrgIddashboardDashboardRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/agenda/': {
      id: '/_authenticated/org/$orgId/agenda/'
      path: '/agenda'
      fullPath: '/org/$orgId/agenda/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdAgendaIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/equipments/': {
      id: '/_authenticated/org/$orgId/equipments/'
      path: '/equipments'
      fullPath: '/org/$orgId/equipments/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdEquipmentsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/equipments/$equipmentId': {
      id: '/_authenticated/org/$orgId/equipments/$equipmentId'
      path: '/equipments/$equipmentId'
      fullPath: '/org/$orgId/equipments/$equipmentId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdEquipmentsEquipmentIdRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/equipments/new': {
      id: '/_authenticated/org/$orgId/equipments/new'
      path: '/equipments/new'
      fullPath: '/org/$orgId/equipments/new'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdEquipmentsNewRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/interventions/': {
      id: '/_authenticated/org/$orgId/interventions/'
      path: '/'
      fullPath: '/org/$orgId/interventions/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdInterventionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdInterventionsRouteRoute
    }
    '/_authenticated/org/$orgId/interventions/$interventionId': {
      id: '/_authenticated/org/$orgId/interventions/$interventionId'
      path: '/$interventionId'
      fullPath: '/org/$orgId/interventions/$interventionId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdInterventionsInterventionIdRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdInterventionsRouteRoute
    }
    '/_authenticated/org/$orgId/interventions/new': {
      id: '/_authenticated/org/$orgId/interventions/new'
      path: '/new'
      fullPath: '/org/$orgId/interventions/new'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdInterventionsNewRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdInterventionsRouteRoute
    }
    '/_authenticated/org/$orgId/invoices/': {
      id: '/_authenticated/org/$orgId/invoices/'
      path: '/invoices'
      fullPath: '/org/$orgId/invoices/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/invoices/reconciliation': {
      id: '/_authenticated/org/$orgId/invoices/reconciliation'
      path: '/invoices/reconciliation'
      fullPath: '/org/$orgId/invoices/reconciliation'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdInvoicesReconciliationRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/notifications/': {
      id: '/_authenticated/org/$orgId/notifications/'
      path: '/notifications'
      fullPath: '/org/$orgId/notifications/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/notifications/all': {
      id: '/_authenticated/org/$orgId/notifications/all'
      path: '/notifications/all'
      fullPath: '/org/$orgId/notifications/all'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdNotificationsAllRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/settings/company': {
      id: '/_authenticated/org/$orgId/settings/company'
      path: '/settings/company'
      fullPath: '/org/$orgId/settings/company'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSettingsCompanyRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/settings/integration': {
      id: '/_authenticated/org/$orgId/settings/integration'
      path: '/settings/integration'
      fullPath: '/org/$orgId/settings/integration'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSettingsIntegrationRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/settings/intervention-rules': {
      id: '/_authenticated/org/$orgId/settings/intervention-rules'
      path: '/settings/intervention-rules'
      fullPath: '/org/$orgId/settings/intervention-rules'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSettingsInterventionRulesRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/settings/settings': {
      id: '/_authenticated/org/$orgId/settings/settings'
      path: '/settings/settings'
      fullPath: '/org/$orgId/settings/settings'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSettingsSettingsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/sites/': {
      id: '/_authenticated/org/$orgId/sites/'
      path: '/sites'
      fullPath: '/org/$orgId/sites/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSitesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/sites/$siteId': {
      id: '/_authenticated/org/$orgId/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/org/$orgId/sites/$siteId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSitesSiteIdRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/sites/import': {
      id: '/_authenticated/org/$orgId/sites/import'
      path: '/sites/import'
      fullPath: '/org/$orgId/sites/import'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSitesImportRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/sites/new': {
      id: '/_authenticated/org/$orgId/sites/new'
      path: '/sites/new'
      fullPath: '/org/$orgId/sites/new'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSitesNewRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/technicians/': {
      id: '/_authenticated/org/$orgId/technicians/'
      path: '/technicians'
      fullPath: '/org/$orgId/technicians/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdTechniciansIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/technicians/$technicianId': {
      id: '/_authenticated/org/$orgId/technicians/$technicianId'
      path: '/technicians/$technicianId'
      fullPath: '/org/$orgId/technicians/$technicianId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdTechniciansTechnicianIdRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/technicians/new': {
      id: '/_authenticated/org/$orgId/technicians/new'
      path: '/technicians/new'
      fullPath: '/org/$orgId/technicians/new'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdTechniciansNewRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/users/': {
      id: '/_authenticated/org/$orgId/users/'
      path: '/users'
      fullPath: '/org/$orgId/users/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdUsersIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/users/$userId': {
      id: '/_authenticated/org/$orgId/users/$userId'
      path: '/users/$userId'
      fullPath: '/org/$orgId/users/$userId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/users/my-profile': {
      id: '/_authenticated/org/$orgId/users/my-profile'
      path: '/users/my-profile'
      fullPath: '/org/$orgId/users/my-profile'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdUsersMyProfileRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/users/new': {
      id: '/_authenticated/org/$orgId/users/new'
      path: '/users/new'
      fullPath: '/org/$orgId/users/new'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdUsersNewRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_invoice-flow/org/$orgId/invoices/$invoiceId': {
      id: '/_invoice-flow/org/$orgId/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/org/$orgId/invoices/$invoiceId'
      preLoaderRoute: typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteImport
      parentRoute: typeof InvoiceFlowOrgOrgIdRoute
    }
    '/_invoice-flow/org/$orgId/invoices/new': {
      id: '/_invoice-flow/org/$orgId/invoices/new'
      path: '/invoices/new'
      fullPath: '/org/$orgId/invoices/new'
      preLoaderRoute: typeof InvoiceFlowOrgOrgIdInvoicesNewRouteImport
      parentRoute: typeof InvoiceFlowOrgOrgIdRoute
    }
    '/_quote-flow/org/$orgId/quotes/$quoteId': {
      id: '/_quote-flow/org/$orgId/quotes/$quoteId'
      path: '/quotes/$quoteId'
      fullPath: '/org/$orgId/quotes/$quoteId'
      preLoaderRoute: typeof QuoteFlowOrgOrgIdQuotesQuoteIdRouteImport
      parentRoute: typeof QuoteFlowOrgOrgIdRoute
    }
    '/_quote-flow/org/$orgId/quotes/new': {
      id: '/_quote-flow/org/$orgId/quotes/new'
      path: '/quotes/new'
      fullPath: '/org/$orgId/quotes/new'
      preLoaderRoute: typeof QuoteFlowOrgOrgIdQuotesNewRouteImport
      parentRoute: typeof QuoteFlowOrgOrgIdRoute
    }
    '/_invoice-flow/org/$orgId/invoices/$invoiceId/preview': {
      id: '/_invoice-flow/org/$orgId/invoices/$invoiceId/preview'
      path: '/preview'
      fullPath: '/org/$orgId/invoices/$invoiceId/preview'
      preLoaderRoute: typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRouteImport
      parentRoute: typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdRoute
    }
    '/_quote-flow/org/$orgId/quotes/$quoteId/preview': {
      id: '/_quote-flow/org/$orgId/quotes/$quoteId/preview'
      path: '/preview'
      fullPath: '/org/$orgId/quotes/$quoteId/preview'
      preLoaderRoute: typeof QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRouteImport
      parentRoute: typeof QuoteFlowOrgOrgIdQuotesQuoteIdRoute
    }
  }
}

interface AuthenticatedOrgOrgIdInterventionsRouteRouteChildren {
  AuthenticatedOrgOrgIdInterventionsInterventionIdRoute: typeof AuthenticatedOrgOrgIdInterventionsInterventionIdRoute
  AuthenticatedOrgOrgIdInterventionsNewRoute: typeof AuthenticatedOrgOrgIdInterventionsNewRoute
  AuthenticatedOrgOrgIdInterventionsIndexRoute: typeof AuthenticatedOrgOrgIdInterventionsIndexRoute
}

const AuthenticatedOrgOrgIdInterventionsRouteRouteChildren: AuthenticatedOrgOrgIdInterventionsRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdInterventionsInterventionIdRoute:
      AuthenticatedOrgOrgIdInterventionsInterventionIdRoute,
    AuthenticatedOrgOrgIdInterventionsNewRoute:
      AuthenticatedOrgOrgIdInterventionsNewRoute,
    AuthenticatedOrgOrgIdInterventionsIndexRoute:
      AuthenticatedOrgOrgIdInterventionsIndexRoute,
  }

const AuthenticatedOrgOrgIdInterventionsRouteRouteWithChildren =
  AuthenticatedOrgOrgIdInterventionsRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdInterventionsRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdRouteChildren {
  AuthenticatedOrgOrgIdInterventionsRouteRoute: typeof AuthenticatedOrgOrgIdInterventionsRouteRouteWithChildren
  AuthenticatedOrgOrgIddashboardDashboardRoute: typeof AuthenticatedOrgOrgIddashboardDashboardRoute
  AuthenticatedOrgOrgIdEquipmentsEquipmentIdRoute: typeof AuthenticatedOrgOrgIdEquipmentsEquipmentIdRoute
  AuthenticatedOrgOrgIdEquipmentsNewRoute: typeof AuthenticatedOrgOrgIdEquipmentsNewRoute
  AuthenticatedOrgOrgIdInvoicesReconciliationRoute: typeof AuthenticatedOrgOrgIdInvoicesReconciliationRoute
  AuthenticatedOrgOrgIdNotificationsAllRoute: typeof AuthenticatedOrgOrgIdNotificationsAllRoute
  AuthenticatedOrgOrgIdSettingsCompanyRoute: typeof AuthenticatedOrgOrgIdSettingsCompanyRoute
  AuthenticatedOrgOrgIdSettingsIntegrationRoute: typeof AuthenticatedOrgOrgIdSettingsIntegrationRoute
  AuthenticatedOrgOrgIdSettingsInterventionRulesRoute: typeof AuthenticatedOrgOrgIdSettingsInterventionRulesRoute
  AuthenticatedOrgOrgIdSettingsSettingsRoute: typeof AuthenticatedOrgOrgIdSettingsSettingsRoute
  AuthenticatedOrgOrgIdSitesSiteIdRoute: typeof AuthenticatedOrgOrgIdSitesSiteIdRoute
  AuthenticatedOrgOrgIdSitesImportRoute: typeof AuthenticatedOrgOrgIdSitesImportRoute
  AuthenticatedOrgOrgIdSitesNewRoute: typeof AuthenticatedOrgOrgIdSitesNewRoute
  AuthenticatedOrgOrgIdTechniciansTechnicianIdRoute: typeof AuthenticatedOrgOrgIdTechniciansTechnicianIdRoute
  AuthenticatedOrgOrgIdTechniciansNewRoute: typeof AuthenticatedOrgOrgIdTechniciansNewRoute
  AuthenticatedOrgOrgIdUsersUserIdRoute: typeof AuthenticatedOrgOrgIdUsersUserIdRoute
  AuthenticatedOrgOrgIdUsersMyProfileRoute: typeof AuthenticatedOrgOrgIdUsersMyProfileRoute
  AuthenticatedOrgOrgIdUsersNewRoute: typeof AuthenticatedOrgOrgIdUsersNewRoute
  AuthenticatedOrgOrgIdAgendaIndexRoute: typeof AuthenticatedOrgOrgIdAgendaIndexRoute
  AuthenticatedOrgOrgIdEquipmentsIndexRoute: typeof AuthenticatedOrgOrgIdEquipmentsIndexRoute
  AuthenticatedOrgOrgIdInvoicesIndexRoute: typeof AuthenticatedOrgOrgIdInvoicesIndexRoute
  AuthenticatedOrgOrgIdNotificationsIndexRoute: typeof AuthenticatedOrgOrgIdNotificationsIndexRoute
  AuthenticatedOrgOrgIdSitesIndexRoute: typeof AuthenticatedOrgOrgIdSitesIndexRoute
  AuthenticatedOrgOrgIdTechniciansIndexRoute: typeof AuthenticatedOrgOrgIdTechniciansIndexRoute
  AuthenticatedOrgOrgIdUsersIndexRoute: typeof AuthenticatedOrgOrgIdUsersIndexRoute
}

const AuthenticatedOrgOrgIdRouteChildren: AuthenticatedOrgOrgIdRouteChildren = {
  AuthenticatedOrgOrgIdInterventionsRouteRoute:
    AuthenticatedOrgOrgIdInterventionsRouteRouteWithChildren,
  AuthenticatedOrgOrgIddashboardDashboardRoute:
    AuthenticatedOrgOrgIddashboardDashboardRoute,
  AuthenticatedOrgOrgIdEquipmentsEquipmentIdRoute:
    AuthenticatedOrgOrgIdEquipmentsEquipmentIdRoute,
  AuthenticatedOrgOrgIdEquipmentsNewRoute:
    AuthenticatedOrgOrgIdEquipmentsNewRoute,
  AuthenticatedOrgOrgIdInvoicesReconciliationRoute:
    AuthenticatedOrgOrgIdInvoicesReconciliationRoute,
  AuthenticatedOrgOrgIdNotificationsAllRoute:
    AuthenticatedOrgOrgIdNotificationsAllRoute,
  AuthenticatedOrgOrgIdSettingsCompanyRoute:
    AuthenticatedOrgOrgIdSettingsCompanyRoute,
  AuthenticatedOrgOrgIdSettingsIntegrationRoute:
    AuthenticatedOrgOrgIdSettingsIntegrationRoute,
  AuthenticatedOrgOrgIdSettingsInterventionRulesRoute:
    AuthenticatedOrgOrgIdSettingsInterventionRulesRoute,
  AuthenticatedOrgOrgIdSettingsSettingsRoute:
    AuthenticatedOrgOrgIdSettingsSettingsRoute,
  AuthenticatedOrgOrgIdSitesSiteIdRoute: AuthenticatedOrgOrgIdSitesSiteIdRoute,
  AuthenticatedOrgOrgIdSitesImportRoute: AuthenticatedOrgOrgIdSitesImportRoute,
  AuthenticatedOrgOrgIdSitesNewRoute: AuthenticatedOrgOrgIdSitesNewRoute,
  AuthenticatedOrgOrgIdTechniciansTechnicianIdRoute:
    AuthenticatedOrgOrgIdTechniciansTechnicianIdRoute,
  AuthenticatedOrgOrgIdTechniciansNewRoute:
    AuthenticatedOrgOrgIdTechniciansNewRoute,
  AuthenticatedOrgOrgIdUsersUserIdRoute: AuthenticatedOrgOrgIdUsersUserIdRoute,
  AuthenticatedOrgOrgIdUsersMyProfileRoute:
    AuthenticatedOrgOrgIdUsersMyProfileRoute,
  AuthenticatedOrgOrgIdUsersNewRoute: AuthenticatedOrgOrgIdUsersNewRoute,
  AuthenticatedOrgOrgIdAgendaIndexRoute: AuthenticatedOrgOrgIdAgendaIndexRoute,
  AuthenticatedOrgOrgIdEquipmentsIndexRoute:
    AuthenticatedOrgOrgIdEquipmentsIndexRoute,
  AuthenticatedOrgOrgIdInvoicesIndexRoute:
    AuthenticatedOrgOrgIdInvoicesIndexRoute,
  AuthenticatedOrgOrgIdNotificationsIndexRoute:
    AuthenticatedOrgOrgIdNotificationsIndexRoute,
  AuthenticatedOrgOrgIdSitesIndexRoute: AuthenticatedOrgOrgIdSitesIndexRoute,
  AuthenticatedOrgOrgIdTechniciansIndexRoute:
    AuthenticatedOrgOrgIdTechniciansIndexRoute,
  AuthenticatedOrgOrgIdUsersIndexRoute: AuthenticatedOrgOrgIdUsersIndexRoute,
}

const AuthenticatedOrgOrgIdRouteWithChildren =
  AuthenticatedOrgOrgIdRoute._addFileChildren(
    AuthenticatedOrgOrgIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedsuperAdminSuperAdminRoute: typeof AuthenticatedsuperAdminSuperAdminRoute
  AuthenticatedOrgOrgIdRoute: typeof AuthenticatedOrgOrgIdRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedsuperAdminSuperAdminRoute:
    AuthenticatedsuperAdminSuperAdminRoute,
  AuthenticatedOrgOrgIdRoute: AuthenticatedOrgOrgIdRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteChildren {
  InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRoute: typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRoute
}

const InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteChildren: InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteChildren =
  {
    InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRoute:
      InvoiceFlowOrgOrgIdInvoicesInvoiceIdPreviewRoute,
  }

const InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteWithChildren =
  InvoiceFlowOrgOrgIdInvoicesInvoiceIdRoute._addFileChildren(
    InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteChildren,
  )

interface InvoiceFlowOrgOrgIdRouteChildren {
  InvoiceFlowOrgOrgIdInvoicesInvoiceIdRoute: typeof InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteWithChildren
  InvoiceFlowOrgOrgIdInvoicesNewRoute: typeof InvoiceFlowOrgOrgIdInvoicesNewRoute
}

const InvoiceFlowOrgOrgIdRouteChildren: InvoiceFlowOrgOrgIdRouteChildren = {
  InvoiceFlowOrgOrgIdInvoicesInvoiceIdRoute:
    InvoiceFlowOrgOrgIdInvoicesInvoiceIdRouteWithChildren,
  InvoiceFlowOrgOrgIdInvoicesNewRoute: InvoiceFlowOrgOrgIdInvoicesNewRoute,
}

const InvoiceFlowOrgOrgIdRouteWithChildren =
  InvoiceFlowOrgOrgIdRoute._addFileChildren(InvoiceFlowOrgOrgIdRouteChildren)

interface InvoiceFlowRouteChildren {
  InvoiceFlowOrgOrgIdRoute: typeof InvoiceFlowOrgOrgIdRouteWithChildren
}

const InvoiceFlowRouteChildren: InvoiceFlowRouteChildren = {
  InvoiceFlowOrgOrgIdRoute: InvoiceFlowOrgOrgIdRouteWithChildren,
}

const InvoiceFlowRouteWithChildren = InvoiceFlowRoute._addFileChildren(
  InvoiceFlowRouteChildren,
)

interface OnboardingRouteChildren {
  OnboardingOrgOrgIdOnboardingRoute: typeof OnboardingOrgOrgIdOnboardingRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingOrgOrgIdOnboardingRoute: OnboardingOrgOrgIdOnboardingRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface QuoteFlowOrgOrgIdQuotesQuoteIdRouteChildren {
  QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRoute: typeof QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRoute
}

const QuoteFlowOrgOrgIdQuotesQuoteIdRouteChildren: QuoteFlowOrgOrgIdQuotesQuoteIdRouteChildren =
  {
    QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRoute:
      QuoteFlowOrgOrgIdQuotesQuoteIdPreviewRoute,
  }

const QuoteFlowOrgOrgIdQuotesQuoteIdRouteWithChildren =
  QuoteFlowOrgOrgIdQuotesQuoteIdRoute._addFileChildren(
    QuoteFlowOrgOrgIdQuotesQuoteIdRouteChildren,
  )

interface QuoteFlowOrgOrgIdRouteChildren {
  QuoteFlowOrgOrgIdQuotesQuoteIdRoute: typeof QuoteFlowOrgOrgIdQuotesQuoteIdRouteWithChildren
  QuoteFlowOrgOrgIdQuotesNewRoute: typeof QuoteFlowOrgOrgIdQuotesNewRoute
}

const QuoteFlowOrgOrgIdRouteChildren: QuoteFlowOrgOrgIdRouteChildren = {
  QuoteFlowOrgOrgIdQuotesQuoteIdRoute:
    QuoteFlowOrgOrgIdQuotesQuoteIdRouteWithChildren,
  QuoteFlowOrgOrgIdQuotesNewRoute: QuoteFlowOrgOrgIdQuotesNewRoute,
}

const QuoteFlowOrgOrgIdRouteWithChildren =
  QuoteFlowOrgOrgIdRoute._addFileChildren(QuoteFlowOrgOrgIdRouteChildren)

interface QuoteFlowRouteChildren {
  QuoteFlowOrgOrgIdRoute: typeof QuoteFlowOrgOrgIdRouteWithChildren
}

const QuoteFlowRouteChildren: QuoteFlowRouteChildren = {
  QuoteFlowOrgOrgIdRoute: QuoteFlowOrgOrgIdRouteWithChildren,
}

const QuoteFlowRouteWithChildren = QuoteFlowRoute._addFileChildren(
  QuoteFlowRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  InvoiceFlowRoute: InvoiceFlowRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  QuoteFlowRoute: QuoteFlowRouteWithChildren,
  ForgotPasswordLazyRoute: ForgotPasswordLazyRoute,
  ResetPasswordLazyRoute: ResetPasswordLazyRoute,
  UnauthorizedLazyRoute: UnauthorizedLazyRoute,
  loginLoginRoute: loginLoginRoute,
  loginAcceptInvitationLazyRoute: loginAcceptInvitationLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
